import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { CitationView } from '@/module/Author/Citation/CitationView';
import { getCitationOptions } from '@/module/Author/Citation/model/CitationQuery';

export const Route = createFileRoute(
  '/_auth/author/_author/article/_article/$articleId/_layout/citations/$citationId/_layout/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { citationId, articleId } = Route.useParams();
  const { data: citation } = useSuspenseQuery(getCitationOptions(articleId, citationId));

  return (
    <CitationView
      citation={citation}
      publicationId={Number(articleId)}
    />
  );
}
